import React, { useState, useEffect, useMemo } from 'react';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { Popover, Button, Checkbox, Modal, message } from 'antd';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import { useAppSelector, useAppDispatch, MailActions } from '@web-common/state/createStore';
import IconCard from '@web-common/components/UI/IconCard';
import styles from './prompt.module.scss';
import { apiHolder, apis } from 'api';
import { getIn18Text } from 'api';
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const replyWriteType = ['replyWithAttach', 'replyAllWithAttach', 'reply', 'replyAll'];
const AddToContactModalData = {
    fun: 'addToContact',
    title: getIn18Text('QUERENTIANJIAZHI'),
    intro: getIn18Text('NINKEGOUXUANXIA'),
};
const RmReceiverModalData = {
    fun: 'rmReceiver',
    title: getIn18Text('QUERENYICHUSHOU'),
    intro: getIn18Text('NINKEGOUXUANXIA2'),
};
const Prompt = _ => {
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const currentMailCid = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid, [currentMail]);
    const currentMailInitSenderStr = useMemo(() => currentMail.initSenderStr, [currentMail]);
    const currentMailOptSender = useMemo(() => currentMail.optSender, [currentMail]);
    const [curMailStangers, setCurMailStangers] = useState([]);
    const [noMorePromptPopoverVis, setNoMorePromptPopoverVis] = useState(false);
    const [modalVis, setModalVis] = useState(false);
    const [modalData, setModalData] = useState({ fun: '', title: '', intro: '' });
    const [checkedEmails, setCheckedEmails] = useState([]);
    const dispatch = useAppDispatch();
    const showPrompt = useMemo(() => {
        const { id, writeType, noPrompt } = currentMail;
        return (id &&
            !currentMail.entry.system &&
            writeType &&
            replyWriteType.includes(writeType) &&
            curMailStangers &&
            curMailStangers.length > 0 &&
            !noPrompt &&
            currentMailInitSenderStr === (currentMailOptSender === null || currentMailOptSender === void 0 ? void 0 : currentMailOptSender.id));
    }, [currentMail, curMailStangers, currentMailInitSenderStr, currentMailOptSender]);
    const promptDetail = useMemo(() => {
        if (!curMailStangers || curMailStangers.length === 0)
            return '';
        const firstOne = curMailStangers[0];
        if (curMailStangers.length === 1)
            return `检测到 ${firstOne.originName}（${firstOne.contactItem.contactItemVal}）不在您的通讯录中，请注意防范风险！`;
        return `检测到 ${firstOne.originName}（${firstOne.contactItem.contactItemVal}）等${curMailStangers.length}人不在您的通讯录中，请注意防范风险！`;
    }, [curMailStangers]);
    const addToContactText = useMemo(() => {
        if (!curMailStangers || curMailStangers.length === 0)
            return '';
        if (curMailStangers.length === 1)
            return `添加至通讯录`;
        return `批量添加至通讯录`;
    }, [curMailStangers]);
    const rmReceiverText = useMemo(() => {
        if (!curMailStangers || curMailStangers.length === 0)
            return '';
        if (curMailStangers.length === 1)
            return `移除收件人`;
        return `批量移除收件人`;
    }, [curMailStangers]);
    const addToContact = () => {
        trackApi.track('pcMail_click_add_mailcontacts_replyMailPage', {});
        if (curMailStangers.length === 1) {
            addToContactAction([curMailStangers[0].contactItem.contactItemVal]);
            return;
        }
        setModalData(AddToContactModalData);
        setModalVis(true);
    };
    const rmReceiver = () => {
        trackApi.track('pcMail_click_remove_mailaddress_replyMailPage', {});
        if (curMailStangers.length === 1) {
            rmReceiverAction([curMailStangers[0].contactItem.contactItemVal]);
            return;
        }
        setModalData(RmReceiverModalData);
        setModalVis(true);
    };
    const noMorePrompt = async () => {
        setNoMorePromptPopoverVis(true);
    };
    const closePrompt = () => {
        setCurMailStangers([]);
        dispatch(MailActions.doChangeNoPrompt(true));
    };
    const cancelModal = () => setModalVis(false);
    const addToContactAction = async (emails) => {
        const curCheckedEmails = emails || checkedEmails;
        const { length: emailLen } = curCheckedEmails;
        const selectedContacts = [];
        curMailStangers.forEach(item => {
            if (curCheckedEmails.includes(item.contactItem.contactItemVal)) {
                selectedContacts.push({
                    name: item.originName || '',
                    emailList: [item.contactItem.contactItemVal],
                });
            }
        });
        try {
            await contactApi.doInsertContact({ list: selectedContacts });
            const filteredStranger = curMailStangers.filter(item => !curCheckedEmails.includes(item.contactItem.contactItemVal));
            message.success(`${emailLen === 1 ? '该联系人已添加至通讯录' : `${emailLen}位联系人已添加至通讯录`}`);
            setCurMailStangers(filteredStranger);
        }
        catch (error) {
            console.log('添加到通讯录失败', error);
            message.error('添加到通讯录失败');
        }
    };
    const rmReceiverAction = async (emails) => {
        const curCheckedEmails = emails || checkedEmails;
        const { length: emailLen } = curCheckedEmails;
        const { receiver = [] } = currentMail;
        const filteredReceiver = receiver.filter(item => !curCheckedEmails.includes(item.contactItem.contactItemVal));
        dispatch(MailActions.doReplaceReceiver(filteredReceiver || []));
        message.success(`${emailLen === 1 ? '该联系人已从回复对象中移除' : `${emailLen}位联系人已从回复对象中移除`}`);
        const filteredStranger = curMailStangers.filter(item => !curCheckedEmails.includes(item.contactItem.contactItemVal));
        setCurMailStangers(filteredStranger);
        return;
    };
    const confirmModal = async () => {
        setModalVis(false);
        const { fun } = modalData;
        if (fun === 'addToContact')
            addToContactAction();
        if (fun === 'rmReceiver')
            rmReceiverAction();
    };
    const cancelPopover = () => setNoMorePromptPopoverVis(false);
    const confirmNoMorePrompt = async () => {
        setNoMorePromptPopoverVis(false);
        setCurMailStangers([]);
        const result = await mailConfApi.updateRiskReminderStatus(false);
        if (result) {
            setCurMailStangers([]);
            message.success(getIn18Text('NINDECAOZUOYI'));
        }
        else {
            message.warn(getIn18Text('GUANLIYUANYISHE'));
        }
    };
    const scanReceiver = () => {
        const { receiver = [] } = currentMail;
        const inValidStrangerFromDB = new Map();
        receiver.forEach(item => {
            var _a;
            const { inContactBook, contactItem } = item;
            if (inContactBook) {
                return;
            }
            const contactItemVal = contactItem.contactItemVal.toLocaleLowerCase();
            const ifSameDomain = accountApi.doGetEmailInCurrentDomain(contactItemVal);
            if (ifSameDomain) {
                return;
            }
            if (!inValidStrangerFromDB.has(contactItemVal)) {
                inValidStrangerFromDB.set(contactItemVal, []);
            }
            (_a = inValidStrangerFromDB.get(contactItemVal)) === null || _a === void 0 ? void 0 : _a.push(item);
        });
        if (!inValidStrangerFromDB.size) {
            return;
        }
        contactApi
            .doGetContactByEmailsAdvance({
            emails: [...inValidStrangerFromDB.keys()],
        })
            .then(({ mapRes }) => {
            Object.keys(mapRes).forEach(email => {
                if (mapRes[email] && mapRes[email].length) {
                    inValidStrangerFromDB.delete(email);
                }
            });
            setCurMailStangers([...inValidStrangerFromDB.values()].flat());
        });
    };
    const onSelectAllChange = (e) => {
        const { checked } = e.target;
        if (checked) {
            setCheckedEmails(curMailStangers.map(item => item.contactItem.contactItemVal));
        }
        else {
            setCheckedEmails([]);
        }
    };
    const onItemChange = (e, index) => {
        const email = curMailStangers[index].contactItem.contactItemVal;
        const { checked } = e.target;
        const tmp = [...checkedEmails];
        const emailIndex = tmp.findIndex(item => item === email);
        if (checked) {
            emailIndex === -1 && tmp.push(email);
        }
        else {
            emailIndex !== -1 && tmp.splice(emailIndex, 1);
        }
        setCheckedEmails(tmp);
    };
    useEffect(() => {
        setCurMailStangers([]);
        if (!currentMailCid)
            return;
        scanReceiver();
    }, [currentMailCid]);
    useEffect(() => {
        if (!modalVis)
            setCheckedEmails([]);
    }, [modalVis]);
    const PopoverTitle = React.createElement("div", { className: styles.popoverTitle }, getIn18Text('QUEDINGBUZAITI'));
    const PopoverContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.popoverContent },
            React.createElement("div", { className: styles.popoverIntro }, getIn18Text('XIACIJINRUBU')),
            React.createElement("div", { className: styles.popoveButtons },
                React.createElement(Button, { onClick: cancelPopover, style: { marginRight: '16px' } }, getIn18Text('QUXIAO')),
                React.createElement(Button, { type: "primary", onClick: confirmNoMorePrompt }, getIn18Text('QUEREN'))))));
    return (React.createElement(React.Fragment, null, showPrompt && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.prompt },
            React.createElement(IconCard, { type: "warnYellow", class: styles.warn }),
            React.createElement("span", { className: styles.promptDetail }, promptDetail),
            React.createElement("div", { className: styles.funs },
                React.createElement("span", { className: styles.funBtn, onClick: addToContact }, addToContactText),
                React.createElement("span", { className: styles.funBtn, onClick: rmReceiver }, rmReceiverText),
                React.createElement(Popover, { overlayClassName: styles.popoverOverlay, overlayInnerStyle: { padding: '20px' }, title: PopoverTitle, content: PopoverContent, placement: "bottom", visible: noMorePromptPopoverVis },
                    React.createElement("span", { className: styles.funBtn, onClick: noMorePrompt }, getIn18Text('BUZAITIXING')))),
            React.createElement(IconCard, { type: "close", className: styles.closeBtn, style: { width: '14px', height: '14px' }, onClick: closePrompt })),
        React.createElement(Modal, { onOk: confirmModal, visible: modalVis, bodyStyle: { padding: 0 }, cancelText: getIn18Text('QUXIAO'), onCancel: cancelModal, okText: getIn18Text('QUEDING'), okButtonProps: (checkedEmails === null || checkedEmails === void 0 ? void 0 : checkedEmails.length) === 0 ? { disabled: true } : {}, onOk: confirmModal, centered: true, destroyOnClose: true, closeIcon: React.createElement(CloseIcon, null) },
            React.createElement("div", { className: styles.header },
                React.createElement("h6", { className: styles.modalTitle }, modalData.title),
                React.createElement("p", { className: styles.modalIntro }, modalData.intro)),
            React.createElement("div", { className: styles.strangerArea },
                React.createElement("div", { className: styles.selectAll },
                    React.createElement(Checkbox, { onChange: onSelectAllChange }),
                    React.createElement("p", { className: styles.selectAllText }, getIn18Text('QUANXUAN'))),
                curMailStangers.map((item, index) => (React.createElement("div", { className: styles.strangerItem },
                    React.createElement(Checkbox, { onChange: e => onItemChange(e, index), checked: !!checkedEmails.includes(item.contactItem.contactItemVal) }),
                    React.createElement(AvatarTag, { className: styles.avatar, key: item.contactItem.contactItemVal, size: 32, user: {
                            name: item.originName,
                            email: item.contactItem.contactItemVal,
                        } }),
                    React.createElement("div", { className: styles.strangerMsgs },
                        React.createElement("p", { className: styles.strangerName }, item.originName),
                        React.createElement("p", { className: styles.strangerEmail }, item.contactItem.contactItemVal)))))))))));
};
export default Prompt;
